import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    getLocation (data) {
        return httpService.get(ApiEndpoints.get('location', data));
    },
    getLocationWithLeader (data) {
        return httpService.get(ApiEndpoints.get('location_leader', data));
    },
    assignLocation (data) {
        return httpService.put(
            ApiEndpoints.get('assign_location', {
                FamilyToAcceptId: data.FamilyToAcceptId,
                wioStructLocationId: data.wioStructLocationId
            })
        );
    }
};
